import { canonicalize } from '@meteor/canonicalize';
import { createLoader } from '@meteor/data-hooks';
import { useRef, useState } from 'react';
import { withAuth } from '../../user';
import { consumerClient } from '../client';

export let clientGroupsLoader = createLoader({
  name: 'clientGroups',
  hash: i => canonicalize(i),
  fetch: (i: {
    instanceId: string;
    userId?: string;
    cursor?: string;
    withDeleted?: boolean;
  }) => withAuth(() => consumerClient.group.list(i)),
  mutators: {
    create: (i: {
      instanceId: string;
      name: string;
      policyId?: string;
      metadata?: Record<string, any>;
    }) => withAuth(() => consumerClient.group.create(i))
  }
});

export let useClientGroups = (instanceId: string | null, userId?: string | null) => {
  let [cursor, setCursor] = useState<string>();

  let groups = clientGroupsLoader.use(
    instanceId ? { instanceId, cursor, userId: userId || undefined } : null
  );

  let dataRef = useRef(groups.data);
  dataRef.current = groups.data;

  return {
    ...groups,
    next: () => {
      let c = dataRef.current?.pagination.afterCursor;
      if (c) setCursor(c);
    },
    previous: () => {
      let c = dataRef.current?.pagination.beforeCursor;
      if (c) setCursor(c);
    },
    createMutator: groups.useMutator('create')
  };
};

export let clientGroupLoader = createLoader({
  name: 'clientGroup',
  fetch: (i: { groupId: string; instanceId: string }) =>
    withAuth(() => consumerClient.group.get(i)),
  mutators: {
    update: (i: {
      groupId: string;
      instanceId: string;
      name?: string;
      policyId?: string;
      metadata?: Record<string, any>;
    }) => withAuth(() => consumerClient.group.update(i))
  }
});

export let useClientGroup = (groupId: string | null, instanceId: string | null) => {
  let group = clientGroupLoader.use(groupId && instanceId ? { groupId, instanceId } : null);

  return {
    ...group,
    updateMutator: group.useMutator('update')
  };
};
